import type { Dispatch } from 'react';

import { sendForm } from '../../../helpers/api/claims-site-api';
import { ERROR, SUCCESS, INN_TRUE, STEP_BY_STEP, SUCCESS_WITH_REDIRECT } from '../../../config';
import type { TStatuses, TRedirectInfo } from '../../../models';
import type { TInnStatus } from '../models';

import { createPresaleRequestData, createDefaultRequestData } from './form-data-builder';
import { sendFormEvent } from './analytics';

const submitPresaleRequests = async (
    setStatus: Dispatch<TStatuses>,
    setRedirectInfo: Dispatch<TRedirectInfo>,
    formId: string,
    values: Record<string, unknown>,
    innStatus: TInnStatus,
    token: string | null
) => {
    setStatus(STEP_BY_STEP);

    try {
        const presaleData = createPresaleRequestData(values, formId);
        const {
            draft_uid: draftUid,
            status: requestStatus,
            uid,
        } = await sendForm(presaleData, true, token);

        setRedirectInfo({ uid, draftUid });

        // посылаем событие для аналитики
        sendFormEvent(
            formId,
            values,
            { result: 'success', presale: true },
            innStatus === 'inn_true'
        );

        const shouldRedirect = requestStatus === 'ACCESS_TO_LK' || requestStatus === 'NOT_EXISTS';

        if (shouldRedirect) {
            setStatus(SUCCESS_WITH_REDIRECT);
        } else {
            setStatus(SUCCESS);
        }
    } catch (e) {
        // посылаем событие для аналитики
        sendFormEvent(formId, values, { result: 'fail', presale: true });

        setStatus(ERROR);

        // если не пришло корректного ответа от сервера, то показываем ошибку, на которую висит метрика через GTM. Пусть на бэке разбираются
        throw new Error('Нет нужных данных в ответе от сервера');
    }
};

const submitDefaultRequests = async (
    setStatus: Dispatch<TStatuses>,
    values: Record<string, unknown>,
    formId: string,
    innStatus: TInnStatus,
    token: string | null
) => {
    try {
        const data = createDefaultRequestData(values, formId, innStatus);
        await sendForm(data, false, token);

        // посылаем событие для аналитики
        sendFormEvent(formId, values, { result: 'success', presale: false });

        setStatus(SUCCESS);
    } catch (error) {
        console.error(error);

        // посылаем событие для аналитики
        sendFormEvent(formId, values, { result: 'fail', presale: false });

        setStatus(ERROR);
    }
};

export const onSubmit =
    (
        setStatus: Dispatch<TStatuses>,
        setRedirectInfo: Dispatch<TRedirectInfo>,
        formId: string,
        innStatus: TInnStatus,
        token: string | null
    ) =>
    async (values: Record<string, unknown>) => {
        if (innStatus === INN_TRUE && (formId === '81' || formId === 'PRSIT00001')) {
            // todo: убрать в будущем проверку на '81'
            await submitPresaleRequests(
                setStatus,
                setRedirectInfo,
                formId,
                values,
                innStatus,
                token
            );
        } else {
            await submitDefaultRequests(setStatus, values, formId, innStatus, token);
        }
    };
